<template>
    <div>
      <trademark-transaction-report></trademark-transaction-report>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  